var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableLinedA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 35,
    viewBox: "0 0 76 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211",
    d: "M1.01172 10.3291H75.5117V10.9749H1.01172V10.3291Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_2",
    d: "M1.01172 14.9124H75.5117V15.5582H1.01172V14.9124Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_3",
    d: "M1.01172 19.4956H75.5117V20.1414H1.01172V19.4956Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_4",
    d: "M1.01172 24.0789H75.5117V24.7247H1.01172V24.0789Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_5",
    d: "M1.01172 28.6624H75.5117V29.3082H1.01172V28.6624Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 4.34985H75.7617V5.49568H0.761719V4.34985Z",
    fill: "#B2B2BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_7",
    d: "M1.01172 33.2456H75.5117V33.8914H1.01172V33.2456Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24001",
    x: 2,
    width: 14,
    height: 4,
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLinedA);
export default __webpack_public_path__ + "static/media/TableLinedA.6757d5b91c63edd16c4af1e17a00e7d7.svg";
export { ForwardRef as ReactComponent };